export default __webpack_public_path__ + "static/media/check-up.6c6e6b09.png";